@if (company()) {
  <mat-toolbar class="header">
    <app-search-field [control]="searchControl"></app-search-field>

    <div class="buttons">
      @if (canCopySettings()) {
        <app-button
          variant="stroked"
          color="neutral"
          (click)="openCopySettingsDialog()">
          <mat-icon>content_copy</mat-icon>
          Copy settings
        </app-button>
      }

      @if (!company()?.is_sso_used) {
        <app-button (click)="openDialogInviteUser()">
          <mat-icon>add</mat-icon>
          Invite new member
        </app-button>
      }
    </div>
  </mat-toolbar>
}

<div
  class="table-container"
  saveHeight
  [bottomOffset]="64">
  <div class="table">
    <table
      mat-table
      [dataSource]="dataSource()"
      matSort
      (matSortChange)="sort.set($event)">
      @for (col of displayedColumns(); track col) {
        <ng-container [matColumnDef]="col">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef>
            {{ tableHeaderList[col] }}
          </th>
          <td
            mat-cell
            class="{{ col }} {{ col === 'status' ? row[col].status : '' }}"
            *matCellDef="let row">
            @switch (col) {
              @case ('first_name') {
                @if (!company()?.is_sso_used) {
                  <a
                    class="cell-link"
                    (click)="openDialogInviteUser(row)"
                    >{{ row | fullName }}</a
                  >
                } @else {
                  {{ row | fullName }}
                }
                <p class="email">{{ row.email }}</p>
                @if (row.sql_query_access || row.has_sql_query_token) {
                  <div class="sql-badges">
                    @if (row.sql_query_access) {
                      <mat-icon
                        class="sql-badge"
                        matTooltip="SQL query access">
                        manage_search
                      </mat-icon>
                    }
                    @if (row.has_sql_query_token) {
                      <mat-icon
                        class="sql-badge sql-badge--token"
                        matTooltip="Token created">
                        key
                      </mat-icon>
                    }
                  </div>
                }
              }
              @case ('role') {
                {{ row[col].name || '-' }}
              }
              @case ('status') {
                {{ row[col].status || '-' }}
              }
              @case ('created_at') {
                {{ row[col] | customDateFormat: 'dd.MM.yyyy, HH:mm:ss' }}
              }
              @case ('last_sign_in_at') {
                {{ row[col] | customDateFormat: 'dd.MM.yyyy, HH:mm:ss' }}
              }
              @case ('actions') {
                <ng-container *ngTemplateOutlet="actions; context: $any({ col, row })"></ng-container>
              }
              @default {
                {{ row[col] }}
              }
            }
          </td>
        </ng-container>
      }

      <ng-container>
        <tr
          class="mat-row"
          *matNoDataRow>
          <td class="mat-cell">
            <div class="empty-block">
              <img
                class="empty-image"
                src="assets/images/empty-state.svg" />
              <h5 class="empty-text">No users</h5>
            </div>
          </td>
        </tr>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns()"></tr>
      <tr
        mat-row
        class="horizontal-line"
        *matRowDef="let row; columns: displayedColumns()"></tr>
    </table>
  </div>
</div>
<mat-paginator
  (page)="pagination.set($event)"
  [length]="length()"
  [pageSize]="25"
  [showFirstLastButtons]="true"
  [pageSizeOptions]="[5, 10, 25]">
</mat-paginator>

<ng-template
  #actions
  let-col="col"
  let-row="row">
  <div class="action-buttons">
    @if (row.invitation_url) {
      <app-button
        class="icon"
        [cdkCopyToClipboard]="row.invitation_url">
        <mat-icon>content_copy</mat-icon>
      </app-button>
    }

    <app-button
      class="icon"
      (click)="openDialogInviteUser(row)">
      <mat-icon>create</mat-icon>
    </app-button>

    @if (row.status.status === 'active') {
      <app-button
        class="icon"
        color="warn"
        (click)="showConfirmResetModal(row)">
        <mat-icon>password</mat-icon>
      </app-button>
    }

    @if (row.status.status !== 'suspended') {
      <app-button
        class="icon"
        color="warn"
        (click)="suspendUser(row, 'block')">
        <mat-icon>block</mat-icon>
      </app-button>
    }

    @if (row.status.status === 'suspended') {
      <app-button
        class="icon"
        (click)="suspendUser(row, 'unblock')">
        <mat-icon>lock_open</mat-icon>
      </app-button>
    }
  </div>
</ng-template>
